import { PageChrome } from '../components/PageChrome';
import { ConnectionTestPanel } from '../components/ConnectionTestPanel';
import { useI18n } from '../i18n';
import { useAppNavigation } from '../navigation/AppNavigationContext';

export function ConnectionTestPage() {
  const { t } = useI18n();
  const { navigationBack } = useAppNavigation();

  return (
    <PageChrome title={t('connection.title')} onBack={() => navigationBack()}>
      <ConnectionTestPanel autoRun />
    </PageChrome>
  );
}
